import { Container } from "./styles";

export const FiltroPeriodo = ({
  periodoInputInicioAux,
  periodoInputFimAux,
  setPeriodoInputInicioAux,
  setPeriodoInputFimAux,
  esconderAte = false,
  titulo = "Período",
}) => {
  return (
    <Container>
      <span>{titulo}</span>
      <div>
        <p>{esconderAte ? "Data: " : "De: "}</p>
        <input
          type="date"
          value={periodoInputInicioAux}
          onChange={(e) => {
            setPeriodoInputInicioAux(e.target.value);
            if (esconderAte) setPeriodoInputFimAux(e.target.value);
          }}
          placeholder="01/01/2020"
        />
      </div>
      {!esconderAte && (
        <div>
          <p>Até: </p>
          <input
            type="date"
            value={periodoInputFimAux}
            onChange={(e) => {
              console.log(e.target.value);
              setPeriodoInputFimAux(e.target.value);
            }}
            placeholder="31/12/2020"
          />
        </div>
      )}
    </Container>
  );
};
